module.exports = __webpack_public_path__ + "static/media/spacex4.f6c61760.png";